export default "__VITE_ASSET__DhY_$f9H__"